export enum ExecTypeEnum {
  New = 0,
  PartiallyFilled = 1,
  Filled = 2,
  Cancelled = 4,
  Replaced = 5,
  Rejected = 8,
  NULL_VALUE = 255
}
